import React, { useState } from "react";
import "../css/contactus.scss";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    comment: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = "tunrisefield customer support";
    const body = [
      `Name: ${formData.name || "Not provided"}`,
      `Reply email: ${formData.email}`,
      "",
      formData.comment,
    ].join("\n");

    window.location.href = `mailto:mall@tunrisefield.xyz?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <div className="contact">
      <div className="contact-content">
        <h1>contact</h1>
        
        <div className="contact-info">
          <p className="contact-intro">Questions, comments, or concerns? Please feel free to reach out to us:</p>
          
          <div className="contact-details">
            <h2>email</h2>
            <p><a href="mailto:mall@tunrisefield.xyz">mall@tunrisefield.xyz</a></p>

            <h2>address</h2>
            <p>Valle Morelia 120, Valle Soleado (FOMERREY-107), 67114 Guadalupe, N.L., MX</p>
            
            <h2>store policies</h2>
            <p>For returns, privacy requests, rights reports, or formal complaints, include the relevant order number and a short description so we can route your message correctly.</p>
          </div>
        </div>
        
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Name"
                className="form-input"
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Email *"
                className="form-input"
                required
              />
            </div>
          </div>
          
          <div className="form-group">
            <textarea
              id="comment"
              name="comment"
              value={formData.comment}
              onChange={handleInputChange}
              placeholder="Comment"
              className="form-textarea"
              rows={4}
            ></textarea>
          </div>
          
          <button type="submit" className="submit-button">
            Send
          </button>
          <p className="contact-form-note">Selecting Send opens your email app so you can review the message before sending.</p>
        </form>
      </div>
    </div>
  );
}

export default Contact;
